<div class="row mb-4" [formGroup]="formGroup()">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header d-flex flex-row justify-content-between align-items-center">
        <h5 class="mb-0">Eingabe {{ inputNumber() }}</h5>
        <button
          type="button"
          class="btn btn-primary cursor-pointer"
          (click)="generateResponse.emit()"
        >
          <span *ngIf="isGenerating()" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isGenerating()" class="bi bi-play-fill me-2"></i>
          Antwort generieren
        </button>
      </div>
      <div class="card-body">
        <textarea
          class="form-control"
          [formControlName]="controlName()"
          rows="10"
          placeholder="..."
        ></textarea>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="card h-100">
      <div class="card-header">
        <h5 class="mb-0">Antwort {{ inputNumber() }}</h5>
      </div>
      <div class="card-body">
        @if (response()) {
          <ng-container>
            <div class="alert alert-success mb-3">
              <i class="bi bi-clock me-2"></i>
              <strong>Antwortzeit:</strong> {{ response()?.responseTime }}ms
            </div>
            <div
                #responseContent
                class="response-content p-3 bg-light rounded"
                [innerHTML]="this.response()?.response ? sanitizedHtml : ''"
            ></div>
          </ng-container>
        } @else {
          <div class="text-muted text-center py-5">
            <i class="bi bi-chat-left-dots fs-1 d-block mb-3"></i>
            @if (!isGenerating()) {
              <p>Noch keine Antwort</p>
            } @else {
              <div class="spinner-border text-primary"></div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
